import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { filter, option } from 'src/interface/shared.interface';
import { ContextService } from 'src/services/platform/context.service';
import { PlatformService } from 'src/services/platform/platform-service.service';

@Component({
  selector: 'app-team-filter',
  templateUrl: './team-filter.component.html',
  styleUrls: ['./team-filter.component.scss'],
})
export class TeamFilterComponent implements OnChanges {
  @Input() disabled: boolean;
  @Input() filter: filter;
  selectedTeam: option[];
  selectedLocation: option[] = [];
  @Output() selectedOptionTeam = new EventEmitter<option[]>();
  @Output() selectedOptionLocation = new EventEmitter<option[]>();
  filterData = this.contextService.filterData;
  allUniqueTerritories: string[] = [];

  constructor(
    private contextService: ContextService,
    private platformService: PlatformService
  ) {}
  selectedOption(option: option[], type: string) {
    this.disabled = true;
    if (type === 'location') {
      this.selectedOptionLocation.emit(option);
    }
    if (type === 'team') {
      this.selectedOptionTeam.emit(option);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    const option = JSON.parse(JSON.stringify(this.filter.option));
    this.selectedTeam = option.filter((x: any) => x.type === 'team');

    this.selectedLocation = option.filter(
      (x: any) => x.type === 'country' || x.type === 'office'
    );
  }
}
